import { Sprout, HeartPulse, FlaskConical } from "lucide-react";

// Each domain carries pre-seeded baseline telemetry, valid operating ranges,
// the laminar safe-holding profile, and a set of Lyapunov fault archetypes.
export const DOMAINS = [
  {
    id: "plant",
    name: "Plant Tissue Micropropagation",
    short: "Plant Tissue",
    code: "DBCA-PTM",
    icon: Sprout,
    accent: "#10B981",
    image:
      "https://images.unsplash.com/photo-1609138429624-82b48e5f4cb0?crop=entropy&cs=srgb&fm=jpg&q=85",
    description:
      "Aseptic clonal explant multiplication on Murashige-Skoog medium under controlled photoperiod.",
    baselines: { ph: 5.72, do2: 86, temp: 24.0, nutrient: 30.0 },
    ranges: {
      ph: [5.5, 5.9],
      do2: [80, 95],
      temp: [22, 26],
      nutrient: [26, 34],
    },
    faults: [
      "Lyapunov V(x) Ascent Violation",
      "Osmotic Nutrient Overshoot",
      "Photoperiod Actuator Saturation",
    ],
  },
  {
    id: "renal",
    name: "Renal Scaffold Perfusion",
    short: "Renal Scaffold",
    code: "DBCA-RSP",
    icon: HeartPulse,
    accent: "#06B6D4",
    image:
      "https://images.unsplash.com/photo-1705871435703-3253908aebe0?crop=entropy&cs=srgb&fm=jpg&q=85",
    description:
      "Decellularized renal scaffold reseeding under pulsatile physiological perfusion.",
    baselines: { ph: 7.4, do2: 95, temp: 37.0, nutrient: 5.5 },
    ranges: {
      ph: [7.35, 7.45],
      do2: [90, 100],
      temp: [36.5, 37.5],
      nutrient: [4.5, 6.5],
    },
    faults: [
      "Lyapunov V(x) Ascent Violation",
      "Perfusion Pressure Divergence",
      "Hypoxic Oxygen Collapse",
    ],
  },
  {
    id: "pharma",
    name: "Pharma Alkaloid Production",
    short: "Pharma Alkaloid",
    code: "DBCA-PAP",
    icon: FlaskConical,
    accent: "#8B5CF6",
    image:
      "https://images.unsplash.com/photo-1605781231474-f60dea478e8a?crop=entropy&cs=srgb&fm=jpg&q=85",
    description:
      "Fed-batch plant cell suspension bioreactor for high-value secondary alkaloid biosynthesis.",
    baselines: { ph: 6.2, do2: 40, temp: 28.0, nutrient: 20.0 },
    ranges: {
      ph: [5.8, 6.5],
      do2: [30, 50],
      temp: [26, 30],
      nutrient: [15, 25],
    },
    faults: [
      "Lyapunov V(x) Ascent Violation",
      "Substrate Feed Runaway",
      "Foaming Aeration Instability",
    ],
  },
];

export const METRICS = [
  { key: "ph", label: "pH", unit: "", testid: "telemetry-card-ph", decimals: 2 },
  { key: "do2", label: "Dissolved O₂", unit: "% sat", testid: "telemetry-card-do2", decimals: 1 },
  { key: "temp", label: "Temperature", unit: "°C", testid: "telemetry-card-temp", decimals: 1 },
  { key: "nutrient", label: "Nutrient Conc.", unit: "g/L", testid: "telemetry-card-nutrient", decimals: 1 },
];

export const FSM_STAGES = [
  { key: "Inducing", color: "#3B82F6", testid: "fsm-stage-inducing" },
  { key: "Stabilizing", color: "#06B6D4", testid: "fsm-stage-stabilizing" },
  { key: "Converting", color: "#8B5CF6", testid: "fsm-stage-converting" },
  { key: "Sustaining", color: "#10B981", testid: "fsm-stage-sustaining" },
];
